import React, { Fragment } from 'react'
import { Radio, Tabs } from 'antd'
import Cookies from 'views/ScanSettings/NewScan/components/Cookies'
import Labels from 'views/ScanSettings/NewScan/components/Labels'
import Flows from 'views/ScanSettings/NewScan/components/Flows'
import WebHooks from 'views/ScanSettings/NewScan/components/WebHooks'
import { PRE_SCAN_SELECTION } from 'views/ScanSettings/NewScan/constants'
import { PanelsContent } from 'views/ScanSettings/NewScan/style'
const { TabPane } = Tabs

const PreFlowStep = ({
	form,
	cookies,
	labels,
	flows,
	webhooks,
	setValidationError
}) => {
	const { getFieldDecorator, getFieldValue } = form
	const currentSelected = getFieldValue(PRE_SCAN_SELECTION) || 'cookies'
	return (
		<Fragment>
			{getFieldDecorator(PRE_SCAN_SELECTION, {
				initialValue: 'cookies'
			})(
				<Radio.Group buttonStyle="solid" size="large">
					<Radio.Button value="cookies">COOKIES</Radio.Button>
					<Radio.Button value="labels">LABELS</Radio.Button>
					<Radio.Button value="flows">FLOWS</Radio.Button>
					<Radio.Button value="webhooks">WEBHOOKS</Radio.Button>
				</Radio.Group>
			)}
			<PanelsContent>
				<Tabs activeKey={currentSelected}>
					<TabPane tab="" key="cookies">
						<Cookies setValidationError={setValidationError} form={form} cookies={cookies} />
					</TabPane>
					<TabPane tab="" key="labels">
						<Labels setValidationError={setValidationError} form={form} labels={labels} />
					</TabPane>
					<TabPane tab="" key="flows">
						<Flows setValidationError={setValidationError} form={form} flows={flows} />
					</TabPane>
					<TabPane tab="" key="webhooks">
						<WebHooks setValidationError={setValidationError} form={form} webhooks={webhooks} />
					</TabPane>
				</Tabs>
			</PanelsContent>
		</Fragment>
	)
}

export default PreFlowStep
